<div class="vtr-ui-list-support">
	<ul class="support-list">
		<li *ngFor="let item of items">
			<a role="link"
				tabindex="0"
				id="{{item.id}}"
				attr.aria-label="{{item.title | translate}}"
				(click)="itemClick(item, $event)"
				(keydown.enter)="itemClick(item, $event)"
				target="_blank"
				title="{{item.title | translate}}">
				<div class="container-fluid">
					<div class="row">
						<div class="col col-1 text-center item-icon-content">
							<div class="item-icon"
								*ngIf="item.icon">
								<div class="icon-bkg">
									<fa-icon [icon]="item.icon"></fa-icon>
								</div>
							</div>
							<div class="item-icon-image"
								*ngIf="item.iconPath">
								<img [src]="item.iconPath|svgInline|async" />
							</div>
						</div>
						<div class="col col-10 item-text d-flex align-items-center">
							<div class="title">
								{{item.title | translate}}
							</div>
						</div>
						<div class="col col-1 text-center">
							<div class="arrow"
								*ngIf="!item.hideArrow">
								<fa-icon [icon]="['fas', 'arrow-right']"></fa-icon>
							</div>
						</div>
					</div>
				</div>
			</a>
		</li>
	</ul>
</div>
